var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row pt-1 pb-1"},[_c('div',{staticClass:"col justify-self-center align-self-center flex-column"},[_c('ul',{staticClass:"nav nav-pills"},_vm._l((_vm.menuTabs),function(menu,index){return _c('li',{key:index,staticClass:"nav-item"},[_vm._t("default",null,{"menu":menu})],2)}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }